// @flow
import React from 'react'
import Tr from '../../../../components/Tr'
import Td from '../../../../components/Td'

type Props = {
  label: string,
  data: string | React$Element<any>
}

const DataRow = ({ label, data }: Props) => {
  if (!data) return null

  return (
    <Tr>
      <Td
        style={{
          width: '30%',
          color: '#96A3B6',
          background: 'rgb(235,238,243)'
        }}
      >
        {label}
      </Td>
      <Td>{data}</Td>
    </Tr>
  )
}

export default DataRow



// WEBPACK FOOTER //
// ./src/views/Property/components/DataRow/index.js